import { render, staticRenderFns } from "./TabbedMenu.vue?vue&type=template&id=7a3b4a18&"
import script from "./TabbedMenu.vue?vue&type=script&lang=js&"
export * from "./TabbedMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a3b4a18')) {
      api.createRecord('7a3b4a18', component.options)
    } else {
      api.reload('7a3b4a18', component.options)
    }
    module.hot.accept("./TabbedMenu.vue?vue&type=template&id=7a3b4a18&", function () {
      api.rerender('7a3b4a18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Components/Navigation/TabbedMenu.vue"
export default component.exports